import "../styles/About.css"
import fatih from "../resources/fatih.jpeg"
const About = (props) => {
    return (
        <div className="about-container" ref={props.refProp}>

            <div className="about-box">

                <div className="about-text">
                    <h2 className="about-header">About Me</h2>
                    <p> I am senior Computer Science & Engineering student in Sabanci University.</p>
                    <p> I have been working on various voluntary projects. </p>
                    <p> I have discrete working experiences.</p>
                    <p> Here are some technologies that I use:</p>

                    <ul className="skills">
                        <li>Python</li>
                        <li>C++</li>
                        <li>HTML + CSS</li>
                        <li>Git</li>
                        <li>Spring Boot</li>
                        <li>ReactJs</li>
                        <li>PostgreSQL,SQL,MySQL</li>
                        <li>Android</li>
                        <li>FB prophet</li>
                    </ul>
                </div>
                <div className="img">
                    <img src={fatih} height={400} />
                </div>
            </div>
        </div>)
}

export default About